<template>
  <v-container
    fluid
  >
    <h2>Quotes tagged with <v-chip dark>{{ tag }}</v-chip></h2>

    <QuoteItem v-for="quote in quotes" :key="quote.id" :quote="quote"/>

  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

import QuoteItem from '../components/QuoteItem.vue'

export default {
  name: 'Tag',
  components: {
    QuoteItem
  },
  data () {
    return {
    }
  },
  mounted () {
    this.$emit('updatenav', -1)
  },
  computed: {
    ...mapGetters(['getQuotesByTag']),
    tag () {
      return this.$route.params.tag
    },
    quotes () {
      return this.getQuotesByTag(this.tag)
    }
  },
  methods: {

  }
}
</script>
